import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler, ArcElement } from 'chart.js';
import { Doughnut, Line } from 'react-chartjs-2';
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, ArcElement, Title, Tooltip, Legend, Filler);

export const ChartWidget = ({type, data, options}) => {

    return (
        <div className='w-100 h-100 p-md-4'>
            {type == 'line' && <Line data={data} options={options}/>}
            {type == 'doughnut' && <Doughnut data={data} options={options}/>}
        </div>
    )
}